import React from 'react';
import css from './SectionFAQ.css';
import Accordion from '../../common/Accordion';
import { questions } from './questions';

export default () => (
    <section className={css.root}>
        <div className={css.content}>
            <h2 className={css.heading}>Häufige Fragen</h2>
        </div>
        <div className={css.faqHolder}>
            <Accordion questions={questions} />
        </div>
        <footer className={css.footer}>
            <p>
                Du hast weitere Fragen?{' '}
                <a href="https://www.horsedeal.com/support">Melde dich bei uns</a> und wir gehen
                persönlich auf dein Anliegen ein.
            </p>
        </footer>
    </section>
);
